var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#EAF0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1511 13.5289C25.9547 13.4333 25.7352 13.3957 25.5182 13.4204C25.3012 13.4451 25.0958 13.5312 24.926 13.6686L22.9475 15.2511V14.9122C22.9928 14.5211 22.9491 14.1248 22.8196 13.7529C22.6902 13.3811 22.4783 13.0433 22.1999 12.7649C21.9215 12.4865 21.5838 12.2746 21.2119 12.1452C20.8401 12.0157 20.4438 11.972 20.0526 12.0174H13.1051C12.7139 11.972 12.3176 12.0157 11.9458 12.1452C11.5739 12.2746 11.2362 12.4865 10.9578 12.7649C10.6794 13.0433 10.4675 13.3811 10.338 13.7529C10.2086 14.1248 10.1649 14.5211 10.2102 14.9122V21.0878C10.1649 21.4789 10.2086 21.8752 10.338 22.2471C10.4675 22.6189 10.6794 22.9567 10.9578 23.2351C11.2362 23.5135 11.5739 23.7254 11.9458 23.8548C12.3176 23.9843 12.7139 24.028 13.1051 23.9826H20.0526C20.4438 24.028 20.8401 23.9843 21.2119 23.8548C21.5838 23.7254 21.9215 23.5135 22.1999 23.2351C22.4783 22.9567 22.6902 22.6189 22.8196 22.2471C22.9491 21.8752 22.9928 21.4789 22.9475 21.0878V20.7489L24.926 22.3314C25.1301 22.4963 25.3846 22.5862 25.647 22.5862C25.8215 22.5859 25.9937 22.5466 26.1511 22.4711C26.3483 22.3773 26.5147 22.2292 26.6309 22.0442C26.7471 21.8593 26.8082 21.6451 26.8072 21.4267V14.5733C26.8082 14.3549 26.7471 14.1407 26.6309 13.9558C26.5147 13.7708 26.3483 13.6227 26.1511 13.5289ZM21.7895 21.0878C21.7895 22.3052 21.27 22.8247 20.0526 22.8247H13.1051C11.8877 22.8247 11.3682 22.3052 11.3682 21.0878V14.9122C11.3682 13.6948 11.8877 13.1753 13.1051 13.1753H20.0526C21.27 13.1753 21.7895 13.6948 21.7895 14.9122V21.0878ZM25.6493 21.4275L22.9475 19.266V16.734L25.6493 14.5725V21.4275Z",
    fill: "#2659C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.bbaca12b16ab23ff7ed906081cc37421.svg";
export { ForwardRef as ReactComponent };